export default __webpack_public_path__ + "static/media/inward2.ab4b2203.svg";